export const DAYS_IN_WEEK = 7;
export const ROWS_IN_MONTH = 6; // Always render 6 rows to avoid layout shifts.
